<mg-auth-wrapper>
  <div class=" d-flex h-100 w-100 py-3 align-items-center h-100 justify-content-center ">
    <img height="70" class="mb-5 float_logo" [src]="logos.ryad" alt="">
    <div class="col-12">
      <div class="mb-4 mx-auto text-center">
        <!-- <img height="70" class="mb-5" [src]="logos?.light" alt=""> -->
        <h2 class="text-white fw-bold mb-3 mb-md-5">
          وكالة الامتثال و الاستدامة البيئية
        </h2>

      </div>
      <div class="card mx-auto mg-card">
        <div class="card-body">
          <form nz-form (keypress.enter)="onSubmit()" [formGroup]="loginForm">
            <h4 class="w-100 fw-bolder text-center text-white mb-3 mb-md-5">
              تسجيــــل الدخول
            </h4>
            <nz-form-item class="mb-3" nzRequired>
              <nz-form-control>
                <nz-form-label [nzRequired]="true" [className]="'text-white fw-bold'">
                  اسم المستخدم
                </nz-form-label>
                <input formControlName="userName" nz-input nzSize="large" name="username"
                  [placeholder]="'اكتب اسم المستخدم أو بريدك الإلكتروني'" type="text" id="username">
              </nz-form-control>
            </nz-form-item>
            <nz-form-item class="mb-1" nzRequired>
              <nz-form-control>
                <nz-form-label [nzRequired]="true" [className]="'text-white fw-bold'">
                  كلمة المرور
                </nz-form-label>
                <input formControlName="password" nz-input nzSize="large" name="password"
                  [placeholder]="'اكتب كلمة المرور'" type="password" id="password">
              </nz-form-control>
            </nz-form-item>
            <div class="col-12">
              <div class="text-end">
                <!-- <a class="text-decoration-underline text-white">
                  <small>
                    هل نسيت كلمة المرور ؟
                  </small>
                </a> -->
              </div>
            </div>
            <button (click)="onSubmit()" [nzLoading]="loading" nz-button class="col-12 bg-gradient border-0 mt-5"
              nzSize="large" [nzType]="'primary'">
              تسجيــــل دخــــول
            </button>

            <button *ngIf="false" routerLink="/account/select-role" nz-button
              class="col-12 mt-2 border-0 bg-white text-primary" nzSize="large" [nzType]="'primary'">
              حســــاب جديــد
            </button>
          </form>
        </div>
      </div>
    </div>
  </div>
  <!-- end container -->
</mg-auth-wrapper>
<!-- end page -->